import styled from '@emotion/styled';
import { Text } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';
import type { PaymentMethod } from '~/subscription-management/api/common/model/payment-method';

const S = {
  TextBlockContainer: styled.div`
    display: flex;
    flex-direction: column;
  `,
};

interface Props {
  creditCardDetails: PaymentMethod<'CREDIT_CARD'>['details'];
}

export function CreditCardInfo({ creditCardDetails }: Props): JSX.Element {
  const { t } = useTranslationWithPrefix('checkout:payment-details');
  const { cardNumber, creditCardType, expirationMonth, expirationYear } = creditCardDetails;

  return (
    <S.TextBlockContainer>
      <Text textType="caption">{cardNumber.match(/.{1,4}/g)?.join(' ')}</Text>
      <Text textType="caption" textColor="text_light">
        {creditCardType} - {t('expires')}: {expirationMonth.toString().padStart(2, '0')}/
        {expirationYear.toString().slice(-2)}
      </Text>
    </S.TextBlockContainer>
  );
}
